<template>
   <div class="crud-wrapper">
      <crud-toolbar :isBlocked="formData.blocked" :modal-mode="modalMode" :new-state="newState" :title="modalTitle"
                    @onCommand="toolbarCommand" showBlock></crud-toolbar>

      <crud-form :modal-mode="modalMode" :ref="formName" v-model="validForm">

         <v-layout row wrap>
            <v-flex xs3>
               <v-card flat style="border-radius: 8px; margin-top: -8px;">
                  <v-img :aspect-ratio="idRatio" :src="media" style="border-radius: 8px"></v-img>
               </v-card>
            </v-flex>

            <v-flex xs9>
               <v-layout row wrap>
                  <a-text-field autofocus label="Descritivo da Filial/Agente" placeholder="(nome do agente, região ou local da filial)"
                                text-transform="capitalize" v-model="formData.storeName"
                                validate="required"></a-text-field>

                  <a-text-field label="CNPJ/CPF" sm6
                                v-mask="['##.###.###/####-##', '###.###.###-##']" v-model="formData.federalId"
                                validate="required"></a-text-field>
                  <a-select-field label="Fuso Horário" obj="timeZoneNames" sm6
                                  v-model="formData.timeZoneId"></a-select-field>
                  <a-text-field label="Fone" sm6 v-mask="['(##) ####-####', '(##) #####-####']"
                                v-model="formData.phone"
                                validate="required"></a-text-field>
                  <a-text-field label="WhatsApp" sm6 v-mask="['(##) ####-####', '(##) #####-####']"
                                v-model="formData.whatsapp"></a-text-field>
               </v-layout>
            </v-flex>

            <a-text-field label="Email" v-model="formData.email" validate="email"></a-text-field>
            <a-text-field label="Endereço" text-transform="capitalize" v-model="formData.address"></a-text-field>
            <a-text-field label="Cidade" md6 text-transform="capitalize" v-model="formData.city"></a-text-field>
            <a-text-field label="Estado" md3 text-transform="uppercase" v-model="formData.state"></a-text-field>
            <a-text-field label="CEP" mask="##.###-###" md3 v-model="formData.zipcode"></a-text-field>

         </v-layout>

         <template slot="rightContent">
            <v-card class="mb-4" color="rgba(0,0,0, 0.03)" flat style="border-radius: 12px; margin-top: -10px">
               <v-toolbar color="rgba(0,0,0, 0.03)" dense flat>
                  <v-toolbar-title>Usuário Gestor</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-switch class="mt-4" label="Agente Leigo" v-model="formData.dummyPartner"></v-switch>
                  <v-btn @click="copyUser" flat icon small>
                     <v-icon small>far fa-copy</v-icon>
                  </v-btn>
               </v-toolbar>
               <v-layout pt-4 pb-2 px-3 row wrap>
                  <a-text-field label="Celular" sm4 v-mask="['(##) ####-####', '(##) #####-####']"
                                v-model="formData.mobileNumber"
                                validate="required"></a-text-field>

                  <a-text-field label="Usuário" sm4 v-model="formData.loginName"
                                validate="required"></a-text-field>

                  <a-text-field hint="(para primeiro acesso)" label="Senha Temporária" sm4
                                v-model="formData.firstPin"
                                validate="required"></a-text-field>
               </v-layout>
            </v-card>
            <v-card color="rgba(0,0,0, 0.03)" flat style="border-radius: 12px;">
               <v-card-title class="pb-1 title text-truncate text-no-wrap" primary-title>
                  Usuários destinados à Filial/Agente
               </v-card-title>
               <v-card-text class="pt-0">
                  Você pode destinar acessos até o limite contratado que sua empresa possui.
                  A quantidade que você estabelecer aqui vai deduzir da quantidade de acessos simultâneos que possuir.
               </v-card-text>
               <v-container pa-0>
                  <v-layout row wrap>
                     <v-flex style="text-align: center" xs4>
                        <label class="biggerNumber text-center">{{formData.maxPaQty}}</label>
                     </v-flex>
                     <v-flex align-self-center xs8>
                        <v-btn @click="subPA" dark fab small>
                           <v-icon small>fas fa-minus</v-icon>
                        </v-btn>
                        <v-btn @click="addPA" color="primary" dark fab small>
                           <v-icon small>fas fa-plus</v-icon>
                        </v-btn>
                     </v-flex>
                     <v-flex xs12>
                        <v-divider></v-divider>
                     </v-flex>
                     <v-flex style="text-align: center" xs4>
                        <label class="bigNumber text-center">{{formData.qtyUsers}}</label>
                     </v-flex>
                     <v-flex align-self-center xs8>
                        <v-label class="text-primary">Usuários Cadastrados</v-label>
                     </v-flex>
                     <v-flex v-if="!formData.partner" xs12>
                        <v-divider inset></v-divider>
                     </v-flex>
                     <v-flex style="text-align: center" v-if="!formData.partner" xs4>
                        <label class="bigNumber text-center">{{formData.qtyPartners}}</label>
                     </v-flex>
                     <v-flex align-self-center v-if="!formData.partner" xs8>
                        <v-label class="text-primary">Parceiros Cadastrados</v-label>
                     </v-flex>
                  </v-layout>
               </v-container>
            </v-card>
         </template>

      </crud-form>

   </div>


</template>

<script>
   let cbTemplate = `
      Seu usuário no Consigmais é: *{0}*
      e sua senha temporária é: *{1}*.
      Lembre-se de altera-la em seu próximo acesso a https://app.consigmais.com.br
   `;

   import CrudFormClass from '@consigmais-team/vue-common/layout/crudPage/crudFormClass';

   export default CrudFormClass.extend({
      name: 'BranchForm',

      data: function () {
         return {
            title: 'Filiais/Agentes',
            formName: 'branchForm',

            formData: {
               id: null,
               storeName: null,
               logo: null,
               brandLogo: null,
               address: null,
               city: null,
               state: null,
               zipcode: null,
               federalId: null,
               phone: null,
               whatsapp: null,
               email: null,
               timeZoneId: 'America/Sao_Paulo',
               notes: null,
               partner: 1,
               paQty: 1,
               maxPaQty: 0,
               qtyUsers: 0,
               qtyPartners: 0,
               blocked: 0,
               pasLeft: 0,
               dummyPartner: false,
               managerId: null,
               loginName: null,
               firstPin: null,
               mobileNumber: null
            }
         };
      },

      computed: {
         idRatio() {
            let mediaRatio = 1;
            return mediaRatio;
         },

         media() {
            let media = '/static/images/empty-logo.jpg';

               console.log(this.formData.brandLogo);
            if (this.formData.brandLogo) {
               media = this.$config.imageUri(this.formData.brandLogo, 'logo');
            }

            return media;
         }
      },

      methods: {
         afterSave (data) {
            if (!this.newState) {
               this.formData.pasLeft = data.pasLeft;
               this.formData.managerId = data.managerId;
            }
         },

         subPA () {
            if (this.formData.maxPaQty > 0) {
               this.formData.maxPaQty--;
            }
         },

         addPA () {
            if (this.formData.maxPaQty < this.formData.pasLeft) {
               this.formData.maxPaQty++;
            } else {
               this.$notifyUser({
                  type: 'info',
                  message: `Favor ligar para (84) 99999-9999 contratar mais PAs.`
               });
            }
         },

         copyUser () {
            window.Clipboard.copy(cbTemplate.format(this.formData.loginName, this.formData.firstPin));
            this.$notifyUser({
               type: 'info',
               message: `Usuário gestor copiado para área de transferência`,
               position: 'top right'
            });
         }
      },
   });
</script>

<style scoped>
   .bigNumber {
      font-size: 40px;
      font-weight: 400;
   }

   .biggerNumber {
      font-size: 60px;
      font-weight: 500;
   }

</style>



// WEBPACK FOOTER //
// src/pages/BranchForm.vue